export const options = [
  { label: 'Ativado', value: 1 },
  { label: 'Desativado', value: 0 },
];
